export const cloudFunctionsBaseUrl = `https://us-central1-neurosity-device.cloudfunctions.net`;
export const localCloudFunctionsBaseUrl = `http://localhost:5001/neurosity-device/us-central1`;
